module.exports = __webpack_public_path__ + "static/img/clearing_02.ceb4676b.svg";